import React, { useState, useEffect, useContext } from "react";

import { Preview } from "@creatomate/preview";
import { useTimelineScale } from "../contexts/TimelineScaleContext";

const WIDTH_ADJUSTMENT = 0;
const SVG_DEFAULT_WIDTH = 600;

interface TimelineRulerProps {
  hidden?: boolean;
  preview: Preview;
  timelineHeight: number;
  timelineWidth: number;
}

const TimelineRuler: React.FC<TimelineRulerProps> = ({
  hidden, preview, timelineHeight, timelineWidth
}) => {
  const { timelineScale } = useTimelineScale();

  const [marksEvery5Seconds, setMarksEvery5Seconds]: Array<any> = useState([]);
  const [marksEverySecond, setMarksEverySecond]: Array<any> = useState([]);
  const [timelineLimit, setTimelineLimit] = useState(SVG_DEFAULT_WIDTH);

  const duration = preview.state?.duration || 0;

  useEffect(
    () => {
      const localMarksEverySecond = [];
      const localMarksEvery5Seconds = [];

      for (let index = 0; index <= timelineLimit; index += 1) {
        const position = index * timelineScale;
        const isFiveSecondMark = index % 5 === 0;

        localMarksEverySecond.push(<polyline key={`polyline-${index}`} x1={position} y1={0} x2={position} y2={10} stroke="black" />);
        localMarksEverySecond.push(<circle key={`circle-${index}`} cx={position} cy={5} r={1} fill="black" />);

        if (isFiveSecondMark) {
          localMarksEvery5Seconds.push(
            <text key={`text-${index}`} x={position} y={25} textAnchor="middle">
              {index}s
            </text>
          );
        }
      }
      setMarksEvery5Seconds(localMarksEvery5Seconds);
      setMarksEverySecond(localMarksEverySecond);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [timelineScale]
  );

  useEffect(
    () => {
      setTimelineLimit(Math.max(
        (duration * timelineScale) - WIDTH_ADJUSTMENT,
        (timelineWidth || 0) - WIDTH_ADJUSTMENT,
        SVG_DEFAULT_WIDTH
      ));
    }, [timelineScale, timelineWidth, duration]
  );

  const handleSvgClick = (event: React.MouseEvent<SVGSVGElement, MouseEvent>) => {
    const svgRect = event.currentTarget.getBoundingClientRect();
    const clickX = Math.max(0, event.clientX - svgRect.left);
    const seekto = clickX / timelineScale;

    if (seekto >= 0 && seekto <= duration) {
      preview.setTime(seekto);
    }
  };

  return (
    <div
      className="range"
      style={{
        height: hidden ? "0" : "auto",
        position: "relative",
        visibility: hidden ? "hidden" : "visible",
        zIndex: 3
      }}
    >
      {duration > 0 && timelineWidth > (duration * timelineScale) - WIDTH_ADJUSTMENT
        && (
          <div
            style={{
              position: "absolute",
              top: 0,
              left: (preview.state?.duration || 0) * timelineScale - 1,
              width: timelineWidth
                - ((preview.state?.duration || 0) * timelineScale)
                - WIDTH_ADJUSTMENT,
              height: `${timelineHeight}px`,
              background: "rgba(241, 241, 241, 0.5)",
              zIndex: -1
            }}
          />
        )}
      <div className="width-zoom" style={{ cursor: "pointer" }}>
        <svg width={timelineLimit} height={30} onClick={hidden ? () => {} : handleSvgClick}>
          {marksEvery5Seconds}
          {marksEverySecond}
        </svg>
      </div>
    </div>
  );
};

export default TimelineRuler;
